<template>
  <div id="container">
    <b-container fluid class="app" id="login">
      <b-row
          fluid
          class="align-items-center">
        <b-container>
          <b-row>
            <b-col style="padding-right: 20px">
              <b-img
                  :src="require('../../assets/images/bg-login.png')"/>
            </b-col>
            <b-col
            >
              <b-card-group>
                <b-card id="content">
                  <b-card-body>
                    <v-window
                        v-model="onboarding">
                      <v-window-item>
                        <FormLogin
                            :gotoLoginTab="gotoLoginTab"/>
                      </v-window-item>
                      <v-window-item>
                        <ForgotPassword :gotoLoginTab="gotoLoginTab"/>
                      </v-window-item>
                      <v-window-item>
                        <LoginOTP :gotoLoginTab="gotoLoginTab"/>
                      </v-window-item>
                      <v-window-item>
                        <ChangePassword :gotoLoginTab="gotoLoginTab"
                                        :otp="otp"/>
                      </v-window-item>
                    </v-window>
                  </b-card-body>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
      <footer>
        <b-card-text class="text-center text-white mb-3">{{ $t("ui.version") }}</b-card-text>
      </footer>
    </b-container>
  </div>
</template>

<script>
import FormLogin from "./components/Login.Form.vue";
import LoginOTP from "./components/LoginOTP.vue";
import ForgotPassword from "./components/Login.ForgotPassword.vue";
import ChangePassword from "./components/Login.ChangePassword";
import mixin from "../../mixin";
import storage, { STORAGE } from "../../helper/storage";

export default {
  components: {FormLogin, ForgotPassword, LoginOTP, ChangePassword},
  mixins: [mixin],
  data() {
    return {
      onboarding: 0,
      otp: '',
      isForgotPassword: false,
    };
  },
  mounted() {
    // Show toast message if user was force-logged-out (status 460)
    const msg = storage.getItem(STORAGE.FORCE_LOGOUT_MESSAGE);
    if (msg) {
      this.showToast('warning', this.$t('warning.warning'), msg);
      storage.removeItem(STORAGE.FORCE_LOGOUT_MESSAGE);
    }
  },
  methods: {
    gotoLoginTab(tab, otp) {
      this.onboarding = tab
      this.otp = otp
    },
  }
};
</script>

<style scoped>

.justify-content-center {
  color: #FFFFFF;
}

#container {
  background: linear-gradient(138.82deg, #276ACF 11.65%, #4881D7 21.38%, #4EA4F2 39.57%, #4881D7 65.15%, #276ACF 92.71%);
  background-size: cover; /* for IE9+, Safari 4.1+, Chrome 3.0+, Firefox 3.6+ */
  -webkit-background-size: cover; /* for Safari 3.0 - 4.0 , Chrome 1.0 - 3.0 */
  -moz-background-size: cover; /* optional for Firefox 3.6 */
  -o-background-size: cover; /* for Opera 9.5 */
  margin: 0; /* to remove the default white margin of body */
  padding: 0; /* to remove the default white margin of body */
  overflow: hidden;
}

#content {
  max-height: fit-content;
  border-radius: 16px;
}

.card-body {
  min-width: 20rem;
  padding: 0px 10px 10px;
}</style>
